import React, { Component } from 'react';
// import { Redirect } from 'react-router';


import SearchResultWrapper from '../components/SearchResultWrapper';
import SearchBar from '../components/SearchBar';


import '../styles/SearchPage.css';

class SearchPage extends Component {
    constructor(props) {
        super(props);
        this.state = { query: props.match.params.query };
    }

    render() {
        return (
            <div>
                <div className="search-page-search-bar">
                    <SearchBar />
                </div>
                <div className="search-page-main-container">
                    <SearchResultWrapper query={ this.state.query } />
                </div>
            </div>
        );
    }

    componentDidMount() {
        document.title = this.state.query + ' - Search Results';
    }

    componentDidUpdate() {
        let query = this.props.match.params.query;
        if (query !== this.state.query)
            this.setState({ query: query });
    }
}

export default SearchPage;


// WEBPACK FOOTER //
// ./src/containers/SearchPage.js